export const F_CABECALHO_TIPO_FICHA = 'f_cabecalho_tipo_ficha';
export const F_CABECALHO_NOME_CENTRO = 'f_cabecalho_nome_centro';
export const F_ATENDIMENTO_DATA_ANO = 'f_atendimento_data_ano';
export const F_SOLICITANTE_ESTADO_SIGLA = 'f_solicitante_estado_sigla';
export const F_SOLICITANTE_CODIGO_IBGE = 'f_solicitante_codigo_ibge';
export const F_SOLICITANTE_MUNICIPIO_NOME = 'f_solicitante_municipio_nome';
export const F_PACIENTE_FAIXA_ETARIA = 'f_paciente_faixa_etaria';
export const F_PACIENTE_FAIXA_ETARIA_ORD = 'f_paciente_faixa_etaria_ord';
export const F_PACIENTE_SEXO = 'f_paciente_sexo';
export const F_AGENTE_CLASSE_DESCRICAO_COMB = 'f_agente_classe_descricao_comb';
export const F_AGENTE_GRUPO_DESCRICAO_ASSOC = 'f_agente_grupo_descricao_assoc';
export const F_ACOMPANHAMENTO_QNT_ACOMPANHAMENTOS = 'f_acompanhamento_qnt_acompanhamentos';
export const F_ENCERRAMENTO_EVOLUCAO_CLINICA_DESCRICAO = 'f_encerramento_evolucao_clinica_descricao';
export const F_ENCERRAMENTO_CLASS_GRAVI_DESCRICAO = 'f_encerramento_class_gravi_descricao';
export const F_CIRCUNSTANCIA_EXPOSICAO_DESCRICAO_ASSOC = 'f_circunstancia_exposicao_descricao_assoc';
export const F_VIA_EXPOSICAO_DESCRICAO_ASSOC = 'f_via_exposicao_descricao_assoc';
export const F_ATENDIMENTO_TURNO = 'f_atendimento_turno';
export const F_ATENDIMENTO_DATA_DIA_SEMANA = 'f_atendimento_data_dia_semana';
export const F_ATENDIMENTO_DATA_MES_ROTULO = 'f_atendimento_data_mes_rotulo';
export const F_ATENDIMENTO_LOCAL_ATENDIMENTO = 'f_atendimento_local_atendimento';
export const F_ATENDIMENTO_MEIO_ATENDIMENTO = 'f_atendimento_meio_atendimento';
export const GRUPO = 'grupo';
export const GRUPO_CLASSE = 'grupo_classe';
export const SUBCLASSE = 'subclasse';
export const CLASSE = 'classe';
export const SUBCLASSE_SUBSTANCIA = 'subclasse_substancia';
export const CIRCUNSTANCIA_DESCRICAO = 'circunstancia_descricao';
export const QNT = 'qnt';
